/* ==========================================================================
   ProductCardHe > Client > image
   ========================================================================== */
const ImageClient = require('@bluekiri/alexandria-contrib-components/components/image-rxjs/client/js');
const configuration = require('../config');

/* Init Image Company */
function initTripAdvisor(instance) {
    /* Reference */
    const inst = instance;

    /* selector */
    const { selector } = instance;

    inst.tripadvisor = ImageClient(
        `${selector} [data-component="ImageRxjs"][data-type="${configuration().type.imageTripadvisor}"]`
    );
}

module.exports = {
    initTripAdvisor
};
